import { useEffect } from "react";
import { createPortal } from "react-dom";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export const Lightbox = ({ images, index, onClose, onChange, testId = "lightbox" }) => {
  const open = index !== null && index !== undefined;
  const go = (step) => onChange((index + step + images.length) % images.length);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, index]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;
  const image = images[index];

  return createPortal(
    <div className="lightbox" onClick={onClose} data-testid={testId} role="dialog" aria-modal="true">
      <button className="lightbox-close" onClick={onClose} aria-label="Close" data-testid={`${testId}-close`}>
        <X />
      </button>
      <button className="lightbox-nav lightbox-prev" onClick={(e) => { e.stopPropagation(); go(-1); }} aria-label="Previous" data-testid={`${testId}-prev`}>
        <ChevronLeft />
      </button>
      <img key={image.src} src={image.src} alt={image.alt} className="lightbox-image" onClick={(e) => e.stopPropagation()} data-testid={`${testId}-image`} />
      <button className="lightbox-nav lightbox-next" onClick={(e) => { e.stopPropagation(); go(1); }} aria-label="Next" data-testid={`${testId}-next`}>
        <ChevronRight />
      </button>
      <span className="lightbox-counter" data-testid={`${testId}-counter`}>{index + 1} / {images.length}</span>
    </div>,
    document.body
  );
};
